import React, { useEffect, useState } from 'react';
import { Button, Card } from 'reactstrap';
import { CSVLink } from 'react-csv';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { AreaChart } from '../charts';
import { ThemeColors } from '../../../../../helpers/ThemeColors';
import { EngagementCSV } from './SummaryCSV/EngagementCSV';
const colors = ThemeColors();

const ConservationsChartCard = ({
  labels,
  conversationStatsData,
  conversationNightStatsData,
  fromDate,
  toDate,
  chattimeStatsData,
  chattimeNightStatsData,
  visitorStatsData,
  avatarclickdata,
  isVoice = false,
}) => {
  const [csvData, setCSVData] = useState([]);
  const conversationDatasets = conversationStatsData.map((elem) => elem.count);
  const conversationNightDatasets = conversationNightStatsData.map(
    (elem) => elem.count
  );
  const areaChartData = {
    labels,
    datasets: isVoice
      ? [
        {
          label: 'calls',
          data: conversationDatasets,
          borderColor: colors.themeColor1,
          pointBackgroundColor: colors.foregroundColor,
          pointBorderColor: colors.themeColor1,
          pointHoverBackgroundColor: colors.themeColor1,
          pointHoverBorderColor: colors.foregroundColor,
          pointRadius: 4,
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          fill: false,
          borderWidth: 2,
          backgroundColor: colors.themeColor1_10,
        },
      ]
      : [
        {
          label: 'conversations',
          data: conversationDatasets,
          borderColor: colors.themeColor1,
          pointBackgroundColor: colors.foregroundColor,
          pointBorderColor: colors.themeColor1,
          pointHoverBackgroundColor: colors.themeColor1,
          pointHoverBorderColor: colors.foregroundColor,
          pointRadius: 4,
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          fill: false,
          borderWidth: 2,
          backgroundColor: colors.themeColor1_10,
        },
        {
          label: 'night',
          data: conversationNightDatasets,
          borderColor: colors.themeColor2,
          pointBackgroundColor: colors.foregroundColor,
          pointBorderColor: colors.themeColor2,
          pointHoverBackgroundColor: colors.themeColor2,
          pointHoverBorderColor: colors.foregroundColor,
          pointRadius: 4,
          pointBorderWidth: 2,
          pointHoverRadius: 5,
          fill: true,
          borderWidth: 2,
          backgroundColor: colors.themeColor2_10,
        },
      ],
  };
  useEffect(() => {
    var tble = EngagementCSV(
      conversationStatsData,
      conversationNightStatsData,
      fromDate,
      toDate,
      chattimeStatsData,
      chattimeNightStatsData,
      visitorStatsData,
      avatarclickdata
    );

    setCSVData(tble);
  }, [
    visitorStatsData,
    avatarclickdata,
    conversationStatsData,
    conversationNightStatsData,
    chattimeStatsData,
    chattimeNightStatsData,
  ]);

  return (
    <Card className="dashboard-filled-line-chart">
      <div style={{ padding: '15px' }}>
        <div className="float-left float-none-xs">
          <div className="d-inline-block">
            <h5 className="d-inline">
              {isVoice ? (
                'Conversation Time'
              ) : (
                <IntlMessages id="dashboards.digital-assistant-engagement" />
              )}
            </h5>
            <span className="text-muted text-small d-block">
              {isVoice ? (
                'Total Minutes (rounded up) and actuals'
              ) : (
                <IntlMessages id="dashboards.total-overnight-conversations" />
              )}
            </span>
          </div>
        </div>
        <div className="float-right">
          <CSVLink
            data={csvData}
            headers={[
              { key: 'r1', label: '' },
              { key: 'r2', label: '' },
              { key: 'r3', label: '' },
              { key: 'r4', label: '' },
              { key: 'r5', label: '' },
              { key: 'r6', label: '' },
              { key: 'r7', label: '' },
            ]}
            filename="digital-assistant-engagement.csv"
          >
            <Button color="primary" outline size="xs">
              <IntlMessages id='dashboards.download' />
            </Button>
          </CSVLink>
        </div>
      </div>

      <div className="chart card-body pt-0">
        <AreaChart shadow data={areaChartData} />
      </div>
    </Card>
  );
};

export default ConservationsChartCard;
